export const parseRewardsPeriod = (period: string): { year: number; month: number } | null => {
  const [yearStr, monthStr] = period.split('-')
  const year = Number(yearStr)
  const month = Number(monthStr)
  if (Number.isNaN(year) || Number.isNaN(month)) {
    return null
  }
  return { year, month }
}

export const monthName = (monthNumber: number): string | null => {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ] as const
  return monthNames[monthNumber - 1] ?? null
}

export const monthNameShort = (monthNumber: number): string | null => {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ] as const
  return monthNames[monthNumber - 1] ?? null
}
